import { ActivityItem as FluentActivityItem } from "@fluentui/react";

export const ActivityItem = FluentActivityItem;
